const fetchAllUsers = () => {
    console.log('fetchAllUsers: ');
};

const fetchUserById = (id) => {
    console.log('fetchUserById: ');
};

const updateUserById = (id) => {
    console.log('updateUserById: ');
};

export default { fetchAllUsers, fetchUserById, updateUserById };